module.exports = __webpack_public_path__ + "img/Slide12.0f3915f4.png";